import { i18nProvider } from "@trumpf/ux.i18n";
import { h, Host, forceUpdate } from "@stencil/core";
import { getNotificationProvider } from "../../apis/notifications";
import { isDefined } from "../../utils/type-check";
import { createNotificationCluster, getClusterName } from "./utils";
const baseClass = "uxc-app-notification-list";
export class AppNotificationList {
    constructor() {
        this.notificationSubscriberId = "";
        this.i18nSubscriberId = "";
        this.renderNotificationItem = (data) => {
            return (h("li", { key: `${data.id}`, class: `${baseClass}__list-item` }, h("ux-notification-item", { source: data.sourceName, headline: data.subject, createdAt: `${data.timestamp}`, dateFormat: this.dateFormat, timeFormat: this.timeFormat, severity: data.severity, type: "Overview" }, h("span", { slot: "message" }, data.message))));
        };
        this.renderError = (err) => {
            const { t } = i18nProvider;
            switch (err.status) {
                case 401:
                    return t("notifications.error.unauthorized", "Unauthorized");
                default:
                    return err.message || t("notifications.error.general");
            }
        };
        this.dateFormat = "YYYY-MM-DD";
        this.timeFormat = "HH:mm:ss";
    }
    connectedCallback() {
        this.notificationSubscriberId = getNotificationProvider().subscribe(() => forceUpdate(this));
        this.i18nSubscriberId = i18nProvider.subscribe(() => forceUpdate(this));
    }
    disconnectedCallback() {
        i18nProvider.unsubscribe(this.i18nSubscriberId);
        getNotificationProvider().unsubscribe(this.notificationSubscriberId);
    }
    render() {
        const { t } = i18nProvider;
        const { notifications, error, pending, loadMore } = getNotificationProvider();
        const hasNotifications = notifications.length > 0;
        const cluster = createNotificationCluster(notifications);
        return (h(Host, { key: '6f1f6088e25f549c8bbd4cbecb0ebc7e3be2aef7', class: {
                [`${baseClass}`]: true
            } }, hasNotifications &&
            Object.entries(cluster).map(([clusterName, notifications]) => (h("div", { key: clusterName, class: `${baseClass}__cluster` }, h("header", { class: `${baseClass}__list-header` }, getClusterName(clusterName)), h("ul", { class: `${baseClass}__list` }, notifications.map(this.renderNotificationItem))))), h("div", { key: 'd1d71ea70e1f8805a378d7f06a29834083c6870d', class: `${baseClass}__list-footer` }, pending && h("div", { key: '0e68e4bc8e693b6639812af22bb9e56eec1a461f', class: "ux-horizontal-loader" }), !pending && hasNotifications && loadMore && (h("div", { key: 'ee0071b6961d64efa3deaa4ecdeb656251e7cd87', class: `${baseClass}__load-more` }, h("ux-button", { key: 'e9cfe7323ff8376fc05b3b71cf2ad0879dde1e69', onClick: loadMore }, t("notifications.button.loadMore")))), !pending && !hasNotifications && !isDefined(error) && (h("div", { key: '62f5a4dbaa58c637b2f766eb37e3176da45636e2', class: `${baseClass}__msg--info` }, t("notifications.info.noNotification", "No notifications"))), !pending && !hasNotifications && isDefined(error) && (h("div", { key: '02ad620fe17ec83bc7aef29db154b04f57890738', class: `${baseClass}__msg--error` }, this.renderError(error))))));
    }
    static get is() { return "uxc-app-notification-list"; }
    static get originalStyleUrls() {
        return {
            "$": ["app-notification-list.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["app-notification-list.css"]
        };
    }
    static get properties() {
        return {
            "dateFormat": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "date format for notifications"
                },
                "attribute": "date-format",
                "reflect": false,
                "defaultValue": "\"YYYY-MM-DD\""
            },
            "timeFormat": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "time format for notifications"
                },
                "attribute": "time-format",
                "reflect": false,
                "defaultValue": "\"HH:mm:ss\""
            }
        };
    }
    static get elementRef() { return "element"; }
}
//# sourceMappingURL=app-notification-list.js.map
